import React, { useEffect, useState } from 'react'
import DragDropFileUpload from '../../CommonComponents/DragDropFileUpload'
import ThreeStateToggleButton from '../../CommonComponents/ThreeStateToggleButton'
import { Loader } from 'rsuite';
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import CheckboxComponent from '../../CommonComponents/CheckboxComponent';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import ModalComponent from '../../CommonComponents/Modal';
import CreateContact from '../../ContactsComponent/createContact';
import ContactView from '../../ContactsComponent/contactView';
import AllContacts from '../../ContactsComponent/allContacts';
import { getExistingContacts } from '../../../redux/actions/contact';
import { toast } from '../../CommonComponents/ToastComponent/toast';

const CreateMasterAchTab = ({ columns, achInfo, achInstructionFile, onChangeAchInfo, onChangeAchInstructionFile, childAchInfo, handleAchEmailFocusOut, isEmailValid, isValidatingEmail, isFromList, portalURLError, setPortalURLError, setAllContacts, allContacts }) => {
  const isAcceptAchPayments = achInfo['isAcceptAchPayments']?.value
  const isAcceptChildAchPayments = childAchInfo['isAcceptAchPayments']?.value
  const isAchThroughPortal = achInfo['isAchThroughPortal']?.value

  const dispatch = useDispatch()
  const [showAllContacts, setShowAllContacts] = useState(false)
  const [existedContacts, setExistedContacts] = useState([])
  const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
  const [currentContact, setCurrentContact] = useState({})
  const [showAddNewContact, setShowAddNewContact] = useState(false)
  const [contactDataFromField, setContactDataFromField] = useState({})

  const handleFileChosen = (file) => {
    if (
      !file
    ) {
      return
    }
    onChangeAchInstructionFile(file)
  }

  const handleEmailAchFocusOut = (emailValue, isRetry = false) => {
    handleAchEmailFocusOut(emailValue, false, isRetry)
  }

  const onContactMouseHover = (event) => {
    if (event.target?.dataset?.contactId) {
      const contact = allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
      setCurrentContact(contact ? contact : {})
    } else {
      setCurrentContact({})
    }
    if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
      event.target.nextSibling.style.display = 'block'
    }
  }

  const onContactMouseHoverOut = (event) => {
    if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
      event.target.nextSibling.style.display = 'none'
    }
    setCurrentContact({})
  }

  const onEmailClick = () => {
    setShowAllContacts(!showAllContacts)
    setExistedContacts(allContacts)
  }

  const onEmailFocusOutClick = () => {
    setShowAllContacts(false)
    setExistedContacts(allContacts)
  }

  useEffect(() => {
    if (showAllContacts && achInfo?.emailAch?.value?.trim() && achInfo?.emailAch?.value?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(achInfo?.emailAch?.value?.trim(), 'email')
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [achInfo?.emailAch?.value])

  const onGetExistingContacts = (searchValue, type = '') => {
    try {
      setIsLoadingExistingContacts(true)
      dispatch(getExistingContacts({ searchValue, type })).then((res) => {
        if (res?.contacts && res?.contacts?.length > 0) {
          setExistedContacts(res?.contacts)
        } else {
          setExistedContacts([])
        }
        setIsLoadingExistingContacts(false)
      }).catch(() => {
        setExistedContacts([])
        setIsLoadingExistingContacts(false)
      })
    } catch (err) {
      setExistedContacts([])
      setIsLoadingExistingContacts(false)
    }
  }

  const handleContactClick = async (rowData) => {
    if (!rowData?.email) {
      toast.show({
        title: 'Warning',
        description: 'No email is assigned to this contact!'
      })
      return
    }
    var value = {}
    value.label = rowData?.email || ''
    value.value = rowData?.email || ''
    value.emailContactId = rowData?.id || null
    if (rowData) {
      const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
      const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
      if (index === -1) {
        tmpContacts.push(rowData)
      }
      setAllContacts(tmpContacts)
    }
    onChangeAchInfo('emailAch', value)
    await handleEmailAchFocusOut(value?.value)
    onEmailFocusOutClick()
  }

  const onCreateContact = () => {
    let value = ''
    let colName = ''
    colName = 'emailAch'
    value = achInfo?.emailAch?.value || ''
    setShowAddNewContact(true)
    setContactDataFromField({
      colName: 'email',
      value
    })
    handleEmailAchFocusOut(value)
  }

  const handleCreateContactClose = async (e, isGetContactsData = false, contact = null) => {
    const contactId = contact?.id || null
    if (contactId) {
      contact.contactName = contact?.firstname + ' ' + contact?.lastname
      const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
      tmpContacts.push(contact)
      var value = {}
      value.label = contact?.email || ''
      value.value = contact?.email || ''
      value.emailContactId = contactId
      onChangeAchInfo('emailAch', value)
      setAllContacts(tmpContacts)
      setExistedContacts(tmpContacts)
    }

    setContactDataFromField({})
    setShowAddNewContact(false)
    onEmailFocusOutClick()
  }

  const onGetContactsData = () => {
    if (showAllContacts) {
      onGetExistingContacts(achInfo?.emailAch?.value?.trim(), 'email')
    }
  }

  const handleRemoveContact = () => {
    var value = {}
    value.label = ''
    value.value = ''
    value.emailContactId = null
    onChangeAchInfo('emailAch', value)
  }

  return (
    <div className="ach-tab">
      <div className="accept-list">
        <div className="accept-item">
          <h4 className='fw-bold toggle-item-text text-black mb-0'>Do they accept ACH Payments?</h4>
          {!isFromList && (<div className='flex justify-end'><ThreeStateToggleButton checked={childAchInfo[columns[0].name].value} isDisabled={true} /></div>)}
          <div className='flex justify-end'><ThreeStateToggleButton checked={achInfo[columns[0].name].value} onChange={(checked) => onChangeAchInfo(columns[0].name, { label: `${checked}`, value: checked })} /></div>
        </div>

        {
          isAcceptAchPayments && (
            <div className="accept-item">
              <h4 className='fw-bold toggle-item-text text-black mb-0'>Is ACH Paid Through Portal?</h4>
              {!isFromList && (
                <div className='flex justify-end'>
                  <ThreeStateToggleButton
                    checked={childAchInfo[columns[6].name].value}
                    isDisabled={true}
                  />
                </div>
              )}
              <div className='flex justify-end'>
                <ThreeStateToggleButton
                  checked={achInfo[columns[6].name].value}
                  onChange={(checked) => onChangeAchInfo(columns[6].name, { label: `${checked}`, value: checked })}
                />
              </div>
            </div>
          )
        }

        {
          (isAcceptAchPayments || isAcceptChildAchPayments) ?
            (
              <>
                {
                  isAchThroughPortal && <div className="accept-item">
                    <h4 className="item-name text-black mb-0">ACH Portal URL:</h4>

                    {!isFromList && (isAcceptChildAchPayments ? (
                      <div className="search-input-parent">
                        <input className='search-input h4 mb-0' type="text" value={childAchInfo[columns[7].name]?.value || ''} disabled={true} />
                      </div>
                    )
                      : <div></div>
                    )}
                    <div className="search-input-parent">
                      <input className='search-input h4 mb-0' type="text" value={achInfo[columns[7].name]?.value || ''} onChange={(e) => onChangeAchInfo(columns[7].name, { label: e.target.value, value: e.target.value })} />
                    </div>
                  </div>
                }
                {isAchThroughPortal === false &&
                  <div className="accept-item">
                    <h4 className="item-name text-black mb-0">Bank Name:</h4>
                    {!isFromList && (isAcceptChildAchPayments ? (
                      <div className="search-input-parent">
                        <input className='search-input h4 mb-0' type="text" value={childAchInfo[columns[5].name]?.value || ''} disabled={true} />
                      </div>
                    )
                      : <div></div>
                    )}
                    {isAcceptAchPayments ? (
                      <div className="search-input-parent">
                        <input className='search-input h4 mb-0' type="text" value={achInfo[columns[5].name]?.value || ''} onChange={(e) => onChangeAchInfo(columns[5].name, { label: e.target.value, value: e.target.value })} />
                      </div>
                    )
                      : <div></div>
                    }
                  </div>
                }
                {isAchThroughPortal === false &&
                  <div className="accept-item">
                    <h4 className="item-name text-black mb-0">Bank Account Number:</h4>
                    {!isFromList && (isAcceptChildAchPayments ? (
                      <div className="search-input-parent">
                        <input className='search-input h4 mb-0' type="text" value={childAchInfo[columns[1].name]?.value || ''} disabled={true} />
                      </div>
                    )
                      : <div></div>
                    )}
                    {isAcceptAchPayments ? (
                      <div className="search-input-parent">
                        <input className='search-input h4 mb-0' type="text" value={achInfo[columns[1].name]?.value || ''} onChange={(e) => onChangeAchInfo(columns[1].name, { label: e.target.value, value: e.target.value })} />
                      </div>
                    )
                      : <div></div>
                    }
                  </div>
                }
                {isAchThroughPortal === false &&
                  <div className="accept-item">
                    <h4 className="item-name text-black mb-0">Bank Routing Number:</h4>
                    {!isFromList && (isAcceptChildAchPayments ? (
                      <div className="search-input-parent">
                        <input className='search-input h4 mb-0' type="text" value={childAchInfo[columns[2].name]?.value || ''} disabled={true} />
                      </div>
                    )
                      : <div></div>
                    )}
                    {isAcceptAchPayments ? (
                      <div className="search-input-parent">
                        <input className='search-input h4 mb-0' type="text" value={achInfo[columns[2].name]?.value || ''} onChange={(e) => onChangeAchInfo(columns[2].name, { label: e.target.value, value: e.target.value })} />
                      </div>
                    )
                      : <div></div>
                    }
                  </div>
                }
                <div className="accept-item ach-instructions">
                  <h4 className="item-name text-black mb-0">ACH Instructions:</h4>
                  {!isFromList && (isAcceptChildAchPayments ? (
                    <DragDropFileUpload
                      currentFileName={childAchInfo[columns[3].name]?.value}
                      customClassName='upload-vendor-file'
                      accept='*.*'
                      isDisabled={true}
                    />
                  )
                    : <div></div>
                  )}
                  {isAcceptAchPayments ? (
                    <DragDropFileUpload
                      currentFileName={achInstructionFile?.name}
                      onFileChosen={handleFileChosen}
                      customClassName='upload-vendor-file'
                      accept='*.*'
                    />
                  )
                    : <div></div>
                  }
                </div>
                <div className="accept-item">
                  <h4 className="item-name text-black mb-0">Email Address for payment notification:</h4>
                  {!isFromList && (isAcceptChildAchPayments ? (
                    <div className="search-input-parent">
                      <input
                        className='search-input h4 mb-0'
                        type="text"
                        value={childAchInfo[columns[4]?.name]?.value || ''}
                        disabled={true}
                      />
                    </div>
                  )
                    : <div></div>
                  )}
                  {isAcceptAchPayments ? (
                    <div className={`search-input-parent phone-input-parent flex align-center${achInfo?.emailContactId?.value ? ' input-group align-items-center' : ''}`}>
                      {achInfo?.emailContactId?.value && (
                        <span role='button' class='border-end-0 input-group-text text-red px-3 fs-2 fw-bold mb-0 position-relative top-0' onClick={() => { handleRemoveContact() }} style={{ height: '48px' }}>X</span>
                      )}
                      <input
                        className='search-input h4 mb-0 text-primary'
                        type="text"
                        style={{ marginLeft: achInfo?.emailContactId?.value ? '-10px' : '0' }}
                        value={achInfo[columns[4].name]?.value || ''}
                        onChange={(e) => onChangeAchInfo(columns[4]?.name, { label: e.target.value, value: e.target.value })}
                        onClick={() => { onEmailClick() }}
                        onMouseOver={(e) => { onContactMouseHover(e) }}
                        onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                        autoComplete='no-email'
                        data-contact-id={achInfo?.emailContactId?.value || ''}
                      // onBlur={() => { handleEmailAchFocusOut(achInfo[columns[4].name]?.value) }}
                      />
                      {achInfo[columns[4].name]?.value && !showAllContacts && (
                        <ContactView contact={currentContact} />
                      )}
                      {showAllContacts && (
                        <AllContacts contacts={existedContacts} onClose={onEmailFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                      )}
                      {isValidatingEmail && (<Loader />)}
                      {achInfo[columns[4].name]?.value && !isValidatingEmail && isEmailValid !== '' &&
                        (isEmailValid ?
                          <BsCheckSquare color="#067911" size={26} />
                          :
                          <>
                            <BsXSquare color="#f75a52" size={26} />
                            <MdOutlineChangeCircle
                              title='Retry'
                              role='button'
                              color="#14438b"
                              size={30}
                              onClick={() => { handleEmailAchFocusOut(achInfo[columns[4].name]?.value, true) }}
                            />
                          </>
                        )
                      }
                    </div>
                  )
                    : <div></div>
                  }
                </div>
              </>
            ) : null
        }
      </div>
      {showAddNewContact && (
        <>
          <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
            <CreateContact onClose={handleCreateContactClose} contactDataFromField={contactDataFromField} />
          </ModalComponent>
        </>
      )}
    </div >
  )
}
export default CreateMasterAchTab